<!--<template>

    <div  class="main-container">
       <div class="grid-box">
    <btn text="Download Salary Reports" type="primary" v-on:click="goToSalaryReports"/>
     <btn text="Jv Reports" type="primary" v-on:click="goToJVReports"/>
        <btn text="IT Reports" type="primary" v-on:click="goToITReports"/>
        <btn text="Increment Arrears Reports" type="primary" v-on:click="goToIncrementReports"/>
        <btn text="Loan Reports" type="primary" v-on:click="goToLoanReports"/>
        <btn text="Profile Reports" type="primary" v-on:click="goToProfileReports"/>
        <btn text="Reports Module" type="primary" v-on:click="goToReports"/>
       </div>
    </div>
</template>-->


<template>
    <div class="d-content">
      <!-- Author: Vaishnavi
      Date: 12/12/2019
      Issue Description: Breadcrumb alignment -->
        <breadcrumb :list="breadcrumbList" />
        <div class="margintop-32" />
        <!-- Myteam View -->
          <btn text="Reports Module" type="primary" v-on:click="goToReports"/> <br>
          <btn text="Payroll Report" type="primary" v-on:click="goToPayrollReport"/>
    </div>
</template>

<script>
export default {
  components: {},
  props: {},
  data() {
    return {
      breadcrumbList:[
              {
                name: "Reports",
                url: `/dashboard/${this.$route.params.entity_index}/reports/reportsDashboard`
              }
        ],
    };
  },
  methods: {

    goToJVReports(){
        this.$router.push({
            path: `/dashboard/${this.$route.params.entity_index}/reports/reportsDashboard/reportModule/jvreports`
        });
      },
      goToITReports(){
        this.$router.push({
            path: `/dashboard/${this.$route.params.entity_index}/reports/reportsDashboard/reportModule/itReports`
        });
      },goToIncrementReports(){
        this.$router.push({
            path: `/dashboard/${this.$route.params.entity_index}/reports/reportsDashboard/reportModule/increment_arrears_Reports`
        });
      },goToLoanReports(){
        this.$router.push({
            path: `/dashboard/${this.$route.params.entity_index}/reports/reportsDashboard/reportModule/loanreports`
        });
      },goToProfileReports(){
        this.$router.push({
            path: `/dashboard/${this.$route.params.entity_index}/reports/reportsDashboard/reportModule/profilereports`
        });
      },
      goToReports(){
        this.$router.push({
            path: `/dashboard/${this.$route.params.entity_index}/reports/reportsDashboard/myReports`
        })
      },
      goToPayrollReport() {
        this.$router.push({
            path: `/dashboard/${this.$route.params.entity_index}/reports/reportsDashboard/payrollreport`
        })
      }
  }
};
</script>

<style lang="scss" scoped>
@import "@/scss/components/margins.scss";  //margins
.grid-box {
  display: grid;
  grid-template-columns: repeat(6,1fr);
  grid-row-gap: 10px;
  // flex-direction: row;
  .btn {
    margin-right: 10px;
  }
}
</style>
